import { ErrorResponse } from 'core/http/response';
import { Declaration } from 'store/declarations/declaration';
import { DeclarationStatuses } from 'store/declarations/enums/common/declaration-status';

// Statuses from which the declaration can still be fixed and resubmitted (mirrors the BE resubmission check).
const editableStatuses: DeclarationStatuses[] = [
    DeclarationStatuses.DRAFT,
    DeclarationStatuses.INVALID,
    DeclarationStatuses.REJECTED,
    DeclarationStatuses.DECLARATION_REJECTED,
];

/**
 * Submission errors live in the store until another request clears them, so after a successful resubmission they
 * would linger. Show them only while the declaration is still editable, and only for field validation errors.
 */
const shouldShowSubmissionErrors = (
    declaration: Declaration | undefined,
    error: ErrorResponse | undefined
): boolean => {
    const hasFieldValidationErrors = !!error?.subErrors?.some((subError) => subError.category === 'VALIDATION');

    const supportsSubmissionErrors = Boolean(
        declaration?.irelandImportDeclaration ||
            declaration?.irelandH7ImportDeclaration ||
            declaration?.entrySummaryDeclaration ||
            declaration?.cdsDeclaration
    );

    const isEditableStatus = !!declaration && editableStatuses.includes(declaration.status);

    return hasFieldValidationErrors && supportsSubmissionErrors && isEditableStatus;
};

export default shouldShowSubmissionErrors;
